<script>
  import { onMount, createEventDispatcher } from "svelte";
  import Map from "../findschools/map.svelte";
  import wrappedFetch from "../../wrappedFetch.js";
  const dispatch = new createEventDispatcher();

  export let laid;
  export let phaseID;
  export let postcode;
  export let gender;
  export let preferences = [];
  export let phaseName="";
  export let LAName="";

  const handleMap = () => {
    let serviceURL = "/Addresses/SearchPostcodeOrLA?postcode=" + postcode;
    //let serviceURL = "https://maptest.lgfl.org.uk/eadmissions/search.ashx?postcode=" + postcode;
    return wrappedFetch(serviceURL)
      .then(response => response.json())
      .then(result => {
        if (result.success) {
          let params = {
            showMap: true,
            selectedLA: result,
            isPostcodeSearch: true,
            postcode: postcode,
            showAddSchool: true,
            phaseName:phaseName,
            LAName:LAName
          };
          params.selectedLA.laId = laid;
          params.selectedLA.phases = [{ phaseId: phaseID }];
          params.gender = gender;
          params.id=1;
          return params;
        } 
      });
  };



  const addSchool = school => {
    dispatch('addSchool', school.detail.school_id);
  };
</script>


{#await handleMap() then params}
<div id="main-div">
<Map
  {...params}
  on:addSchool={addSchool} {preferences}  />
  </div>
{/await}